import { MemberId } from './member-profiles';
import { UserAccountProfile } from './user-account';

export enum WITHDRAWAL_AGGREGATOR_ID {
  CAPITALIST = 0,
  LEOPON = 1,
  CROSSPAY = 2,
  CYPIX = 3,
  DRAGONPAY = 4,
  INXY = 5,
}

export enum WITHDRAWAL_ORDER_STATUS {
  OPENED = 1,
  PAID = 2,
  REJECTED = 3,
  FAILED = 4,
  AWAITING_PAYOUT_RESULT = 5,
}

export enum WITHDRAWAL_PAYOUT_STATUS {
  OPEN = 1,
  CANCELED = 2,
  FAILED = 3,
  PAID = 4,
}

export enum WITHDRAWAL_AUTO_CONFIRMATION_STATUS {
  ENABLED = 1,
  DISABLED = 2,
  NOT_AVAILABLE = 3,
}

export type WithdrawalId = number;

export type WithdrawalProviderId = string;

export type WithdrawalAmount = {
  projectAmount: number;
  projectCurrency: string;
  withdrawalAmount: number;
  withdrawalCurrency: string;
  transactionLink?: string;
};

export type WithdrawalUser = {
  userId: MemberId;
  email: UserAccountProfile['email'];
  ipAddress: string;
};

export type Withdrawal = {
  id: WithdrawalId;
  providerId: WithdrawalProviderId;
  user: WithdrawalUser;
  amount: WithdrawalAmount;
  creationTime: string;
  status: WITHDRAWAL_ORDER_STATUS;
  aggregatorType: WITHDRAWAL_AGGREGATOR_ID;
};

export type Withdrawals = Withdrawal[];

export type WithdrawalsList = {
  items: Withdrawals | undefined;
  totalCount: number;
};

export enum WITHDRAWAL_HISTORY_TYPE {
  UNDEFINED = 0,
  STATUS_CHANGED = 1,
  SET_AGGREGATOR = 2,
  AGGREGATOR_RESULT = 3,
}

export type WithdrawalHistory = {
  id: WithdrawalId;
  creationTime: string;
  status: WITHDRAWAL_ORDER_STATUS;
  comment: string | undefined;
};

export type WithdrawalsHistory = WithdrawalHistory[];
